import script from "./Career.vue?vue&type=script&setup=true&lang=js"
export * from "./Career.vue?vue&type=script&setup=true&lang=js"

import "./Career.vue?vue&type=style&index=0&id=04b42db2&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b42db2"]])

export default __exports__